import { jsx as _jsx } from "react/jsx-runtime";
export var StarFill = function() {
    return /*#__PURE__*/ _jsx("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "filled-star",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M12 20.0477L6.37839 23.022C5.64511 23.41 4.78553 22.7879 4.92494 21.9701L6.00062 15.6604L1.43919 11.1863C0.848808 10.6072 1.17645 9.60257 1.99471 9.4829L8.29186 8.56193L11.1021 2.83096C11.4681 2.08467 12.5319 2.08467 12.8978 2.83096L15.7081 8.56193L22.0053 9.4829C22.8235 9.60257 23.1512 10.6072 22.5608 11.1863L17.9994 15.6604L19.075 21.9701C19.2144 22.7879 18.3549 23.41 17.6216 23.022L12 20.0477Z",
            fill: "#5234B6"
        })
    });
};
